export const ADD_TO_QUEUE = 'ADD_TO_QUEUE'
export const SAVE_QUEUE = 'SAVE_QUEUE'



// WEBPACK FOOTER //
// ./src/store/actions/actionsQueue.js